import { Store } from '@ngrx/store';
import { NavigationStart, Router } from '@angular/router';
import { filter, first } from 'rxjs/operators';

// Store
import { loadLanguagesList } from '@store/languages/languages.actions';
import { loadProfileData, loadProfileTemporaryData } from '@store/profile/profile.actions';
import { loadPaymentCards } from '@store/payments/payments.actions';
import { loadCallHistory } from '@store/call-history/call-history.actions';
import { loadTimezones } from '@store/timezones/timezones.actions';

// Services
import { AuthService } from '@services/auth.service';
import { WidgetsService } from '@services/widgets.service';

// Constants
import { LOCAL_STORAGE_KEYS } from '@constants/storage.constants';

export function initializeUser(authService: AuthService, store: Store, router: Router) {
  return () =>
    new Promise(resolve => {
      // Set the application height based on the window height
      document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);

      const userToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
      const userTemporaryToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TEMPORARY_TOKEN);
      router.events
        .pipe(
          first(),
          filter(event => event instanceof NavigationStart),
        )
        .subscribe({
          next: event => {
            const isDeeplink = event?.['url']?.includes('deeplink');
            authService.isAuthUser$.next((!!userToken || !!userTemporaryToken) && !isDeeplink);
            if (!!userToken && !isDeeplink) {
              store.dispatch(loadProfileData());
              store.dispatch(loadCallHistory({ page: 1, isLoadMore: false }));
              store.dispatch(loadPaymentCards());
              store.dispatch(loadLanguagesList());
              store.dispatch(loadTimezones());
            }
            if (!!userTemporaryToken && !isDeeplink) {
              store.dispatch(loadProfileTemporaryData());
              store.dispatch(loadLanguagesList());
            }
          },
        });
      resolve(true);
    });
}

export function initializeWidget(widgetService: WidgetsService) {
  return () => widgetService.firstLoadWidget$.next(window.location.pathname.includes('widgets'));
}
